import { Component } from 'react';

import { Row, Container, Col, Card } from 'react-bootstrap';

import "./ShowcasePage.scss"

// FIXME: Swap all menu links to use linkcontainer or w/e so they don't reload
// FIXME: Contact page listing discord, email, social media(?)
import graveyard from  "../images/showcase/graveyard_dude.png"
import oopi from "../images/showcase/oopi.png"
import crypto from "../images/showcase/crypto.png"
import evidence from "../images/showcase/evidence.png"

const games = [{
    title: "Graveyard Dude & Senseless City",
    link: 'https://destroyed4com4t.itch.io/graveyard-dude-homebrew-nes-game',
    author: "Rani Timekey Baker",
    authorLink: 'https://destroyed4com4t.itch.io/',
    description: <>
        <p>
            Rani took a very unique approach to her games made with the tool. She was a romhacker, and a talented one 
            at that! She made her games with the tool, then romhacked new features into them. Graveyard Dude featured 
            mid-game music transitions long before the engine supported it, as well as in-game graphical changes and 
            multiple endings. I was blown away when I tried it.
        </p>
        <p>
            Rani follwed this up with Senseless City, a short test that she hoped to expand - she hacked this one to 
            have a character select menu that controls the graphics and music. Both games were quite fun to play, and
            definitely show off what you can do with custom code.
        </p>
    </>,
    img: graveyard,
}, {
    title: "Oopi's Quest",
    link: 'https://kenney.itch.io/oopis-quest',
    author: "Kenney",
    authorLink: 'https://kenney.nl/',
    description: <>
        <p>
            Oopi's quest is a fun little game about an alien crash-landing on an unknown planet, and collecting parts
            to repair his ship. Kenny created a gorgeous and fun little adventure. The graphics are cute and playful,
            to the point it's easy to forget this game targets the original NES. 
        </p>
        <p>
            Kenney has released thousands of game assets for free over the past decade+, and they're all high quality.
            The tool lets you use an adapted version of their {" "}
            <a target="_blank" rel="noreferrer" href="https://kenney.nl/assets/1-bit-pack">1-Bit Pack</a>.{" "}
            Click above to go to Kenney's site, where you can find them! 
        </p>
    </>,
    img: oopi,
}, {
    title: "Crypto-Fascist",
    link: 'https://gamelosers.itch.io/crypto-fascist',
    author: 'Game Losers',
    authorLink: 'https://gamelosers.itch.io/crypto-fascist',
    description: <>
        <p>
            Crypto-Fascist puts you into the role of a government agent, pushing pills and stacking bitcoin. The game's
            levels are very well-balanced, and its difficulty grows in a linear way. It's a fantastic example of what
            is possible with the engine!
        </p>
    </>,
    img: crypto
}, {
    title: "Alien Nah'topsy",
    link: 'https://raftronaut.itch.io/alien-nahtopsy',
    author: 'Raftronaut',
    authorLink: 'https://www.raftlabsinteractive.com/',
    description: <>
        <p>
            Alien Nah'topsy is a little puzzler where you have to help an alien hide DNA evidence before escaping in his UFO. 
            The graphics and music are all by Raftronaut and both fit the game extremely well. 

        </p>
    </>,
    img: evidence
}]

class ShowcasePage extends Component {

    game({title, author, description, link, authorLink, img}, className) {
        return <Card className={`img-card ${className}`} key={link}>
            <a href={link} target="_blank" rel="noreferrer">
                <Card.Img variant={"top"} src={img} />
            </a>
            <Card.Body>
                <Card.Title className="mb-2">
                    <a href={link} target="_blank" rel="noreferrer">{title}</a>
                </Card.Title>

                <Card.Subtitle className="mb-3">
                    <a href={authorLink} target="_blank" rel="noreferrer">{author}</a>
                </Card.Subtitle>
                
                {description}
            </Card.Body>
        </Card>
    }

    render() {
        return (
            <Container className="showcase-page">
                <Row>
                    <Col>
                        <h2 className="mb-4">Showcase</h2>
                        <p>
                            Retro Puzzle Maker has been used for a number of projects over time, many of them beyond what I had really imagined possible.
                            Some of these have influenced further development, and many are just cool. This page shares a few that I think are cool as 
                            a developer. There is no implied relationship in any of these projects. 

                        </p>
                        <p>
                            If you have a project you'd like to show here, reach out! There are multiple methods available in the community menu.
                        </p>
                        
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {games.map((game, idx) => this.game(game, (idx % 2) ? 'left' : 'right'))}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ShowcasePage;
